import React from "react"
import Block from "@bappweb/block"

const LandingFooter = (props) => {

  return (
    <Block type="footer" className="landing-footer-container">
      <Block className="landing-footer-wrapper" />
    </Block>
  )
}

export default LandingFooter
